import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LogService } from 'src/app/services/log.service';

@Component({
  selector: 'app-tank-swap-form-dialog-wrapper',
  templateUrl: './tank-swap-form-dialog-wrapper.component.html',
  styleUrls: ['./tank-swap-form-dialog-wrapper.component.css'],
})
export class TankSwapFormDialogWrapperComponent implements OnInit {
  uniqueId: number;
  isAssign: boolean;
  deviceId: number;
  contextDeviceId: number;
  isHostAssignment: boolean;
  
  constructor(
    private dialogRef: MatDialogRef<TankSwapFormDialogWrapperComponent>,
    @Inject(MAT_DIALOG_DATA) data: { uniqueId: number, isAssign: boolean, deviceId: number | undefined | null, contextDeviceId: number | null | undefined, isHostAssignment?: boolean },
    private _logs: LogService,
  ) {
    if (!data.uniqueId || data.uniqueId === 0) {
      this.dialogRef.close(true);
    }
    this.uniqueId = data.uniqueId;
    this.isAssign = data.isAssign;
    this.deviceId = data.deviceId;
    this.contextDeviceId = data.contextDeviceId;
    this.isHostAssignment = data.isHostAssignment ?? false;
    this._logs.trackEvent('TankSetup', 'Click', 'SwapRTUShowDialogButton', this.uniqueId);
  }

  ngOnInit() {}

  onCancelled() {
    this.closeDialog(true);
  }
  onSwapped() {
    //all the logic for swapping the tank is handled by the TankSwapAssignFormComponent so we just need to close the dialog
    this.closeDialog(false);
  }

  private closeDialog(cancelled: boolean) {
    this.dialogRef.close(cancelled);
  }


}
